import { APIAuthenticatorGateway } from '../../adapters/secondaries/backendAuthenticator.gateway';
import { ApiEventGateway } from '../../adapters/secondaries/event.gateway';
import { ApiFightGateway } from '../../adapters/secondaries/fight.gateway';
import { ApiFighterGateway } from '../../adapters/secondaries/fighter.gateway';
import { FirebaseAuthenticatorGateway } from '../../adapters/secondaries/oidcAuthenticator.gateway';
import { ApiSeasonFightsGateway } from '../../adapters/secondaries/seasonFights.gateway';
import { ApiSeasonGateway } from '../../adapters/secondaries/seasons.gateway';
import { ApiTournamentsGateway } from '../../adapters/secondaries/tournaments.gateway';
import { APIUserGateway } from '../../adapters/secondaries/user.gateway';
import { ApiUserSeasonGateway } from '../../adapters/secondaries/userSeasons.gateway';
import { config } from '../config';
import { Dependencies } from './dependencies.interface';

import { S3FighterImageGateway } from '../../adapters/secondaries/fighterImage.gateway';
import { ApiTempGateGateway } from '../../adapters/secondaries/tempGateway.gateway';
const oidcAuthenticator = new FirebaseAuthenticatorGateway(
  config.OicdAuthenticatorConfig,
);

export const dependencies: Dependencies = {
  fighterGateway: new ApiFighterGateway(config.apiEndpoint),
  eventGateway: new ApiEventGateway(config.apiEndpoint),
  fightGateway: new ApiFightGateway(config.apiEndpoint),
  oicdAuthenticatorGateway: oidcAuthenticator,
  userGateway: new APIUserGateway(config.apiEndpoint),
  backendAuthenticatorGateway: new APIAuthenticatorGateway(
    config.apiEndpoint,
    oidcAuthenticator,
  ),
  seasonFightsGateway: new ApiSeasonFightsGateway(config.apiEndpoint),
  seasonGateway: new ApiSeasonGateway(config.apiEndpoint),
  userSeasonGateway: new ApiUserSeasonGateway(config.apiEndpoint),
  tournamentsGateway: new ApiTournamentsGateway(config.apiEndpoint),
  tempGateGateway: new ApiTempGateGateway(config.apiEndpoint), // REMEMBER temporary gateway
  fighterImageGateway: new S3FighterImageGateway(config.fighterMediaEndpoint),
};
